import { Component, Renderer2, ElementRef, OnInit, inject, input } from '@angular/core';
import { NgClass } from '@angular/common';

export type TagStatus = 'error' | 'warning' | 'success';

@Component({
    selector: 'ap-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss'],
    imports: [NgClass]
})
export class ApTagComponent implements OnInit {
    private readonly renderer = inject(Renderer2);
    private el = inject(ElementRef);

    /**
     * Required - This value sets the color for the tag.
     */
    public readonly status = input.required<TagStatus>();

    public ngOnInit(): void {
        this.setRole();
    }

    protected setRole() {
        if (this.status() === 'error') {
            this.renderer.setAttribute(this.el.nativeElement, 'role', 'alert');
        } else {
            this.renderer.setAttribute(this.el.nativeElement, 'role', 'status');
        }
    }
}
